import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
    Step,
    Stepper,
    StepLabel,
} from 'material-ui/Stepper';

import { Load } from '../../components';
import {
    Utils,
    projetoService,
} from '../../services';
import PrincipalMaster from '../master/Principal';
import PublicMaster from '../master/Public';
import EventosParaInscricao from '../evento/EventosParaInscricao';
import InscricaoStepCategoria from '../inscricao/InscricaoStepCategoria';
import InscricaoStepArea from '../inscricao/InscricaoStepArea';
import InscricaoStepEixo from '../inscricao/InscricaoStepEixo';
import InscricaoStepTema from '../inscricao/InscricaoStepTema';
import InscricaoStepAutores from '../inscricao/InscricaoStepAutores';
import InscricaoStepTermo from '../inscricao/InscricaoStepTermo';

class Inscricao extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stepIndex: 0,
            eventoSelecionado: 0,
            subeventoSelecionado: 0,
            categoriaSelecionada: 0,
            areaSelecionada: 0,
            eixoSelecionado: 0,
            tituloProjeto: '',
            arquivoProjeto: null,
            instituicaoProjeto: '',
            tipoProjeto: 0,
            dsAutores: [],
            carregando: false,
        };
    }

    async onSelecionarEvento(evento, subevento) {
        this.setState({
            stepIndex: 1,
            subeventoSelecionado: subevento,
            eventoSelecionado: evento,
        });
    }

    async onSelecionarCategoria(categoria) {
        this.setState({
            stepIndex: 2,
            categoriaSelecionada: categoria,
        });
    }

    async onSelecionarArea(area) {
        this.setState({
            stepIndex: 3,
            areaSelecionada: area,
        });
    }

    async onSelecionarEixo(eixo) {
        this.setState({
            stepIndex: 4,
            eixoSelecionado: eixo,
        });
    }

    async onInformarTemaProjeto(titulo, instituicao, tipo, arquivo) {
        this.setState({
            stepIndex: 5,
            tituloProjeto: titulo,
            instituicaoProjeto: instituicao,
            arquivoProjeto: arquivo,
            tipoProjeto: tipo,
        });
    }

    async onInformarAutores(autores) {
        this.setState({
            stepIndex: 6,
            dsAutores: autores,
        });
    }

    async onAceitarTermo(form) {
        this.onUpdateStatusLoad(true);
        const {
            eventoSelecionado,
            eixoSelecionado,
            areaSelecionada,
            subeventoSelecionado,
            categoriaSelecionada,
            tituloProjeto,
            instituicaoProjeto,
            tipoProjeto,
            arquivoProjeto,
            dsAutores,
        } = this.state;

        try {
            const response = await projetoService.save({
                evento: eventoSelecionado,
                eixo: eixoSelecionado,
                area: areaSelecionada,
                subevento: subeventoSelecionado,
                categoria: categoriaSelecionada,
                titulo: tituloProjeto,
                instituicao: instituicaoProjeto,
                tipo: tipoProjeto,
                arquivo: arquivoProjeto,
                autores: dsAutores,
            }, form);
            this.onUpdateStatusLoad(false);
            Utils.showToast(response.body.message);
            if (response.status === 200) {
                 //alterar aqui
                if(response.body.NaoAssinaTermo){
                    this.props.history.push(`/inscricao/pagamento/${response.body.codigoProjeto}`);
                } else {
                    this.props.history.push(`/inscricao/resumo/${response.body.codigoProjeto}`);
                } //if (response.body.eventoGratuito) {
            }
        } catch (error) {
            this.onUpdateStatusLoad(false);
            Utils.showToast(error.message);
        }
    }

    async onUpdateStatusLoad(value) {
        this.setState({ carregando: value });
    }

    getDetalhesInscricao() {
        const {
            eventoSelecionado,
            eixoSelecionado,
            areaSelecionada,
            subeventoSelecionado,
            categoriaSelecionada,
            tituloProjeto,
            instituicaoProjeto,
            tipoProjeto,
            arquivoProjeto,
            dsAutores,
        } = this.state;

        return {
            evento: eventoSelecionado,
            eixo: eixoSelecionado,
            area: areaSelecionada,
            subevento: subeventoSelecionado,
            categoria: categoriaSelecionada,
            titulo: tituloProjeto,
            instituicao: instituicaoProjeto,
            tipo: tipoProjeto,
            arquivo: arquivoProjeto,
            autores: dsAutores,
        };
    }

    getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return <EventosParaInscricao onSelecionarEvento={(evento, subevento) => this.onSelecionarEvento(evento, subevento)} />;

            case 1:
                return (
                    <InscricaoStepCategoria
                        subevento={this.state.subeventoSelecionado}
                        onSelecionarCategoria={categoria => this.onSelecionarCategoria(categoria)}
                    />
                );

            case 2:
                return <InscricaoStepArea subevento={this.state.subeventoSelecionado} onSelecionarArea={area => this.onSelecionarArea(area)} />;

            case 3:
                return (
                    <InscricaoStepEixo
                        area={this.state.areaSelecionada}
                        onSelecionarEixo={eixo => this.onSelecionarEixo(eixo)}
                    />
                );

            case 4:
                return (
                    <InscricaoStepTema
                        subevento={this.state.subeventoSelecionado}
                        onInformarTemaProjeto={(titulo, instituicao, tipo, arquivo) => this.onInformarTemaProjeto(titulo, instituicao, tipo, arquivo)}
                    />
                );

            case 5:
                return <InscricaoStepAutores area={this.state.areaSelecionada} 
                instituicao={this.state.instituicaoProjeto} 
                subevento={this.state.subeventoSelecionado}
                onInformarAutores={autores => this.onInformarAutores(autores)} />;

            case 6:
                return <InscricaoStepTermo onAceitarTermo={form => this.onAceitarTermo(form)} detalhesInscricao={this.getDetalhesInscricao()} />;

            default:
                return null;
        }
    }

    render() {
        const {
            stepIndex,
            carregando,
        } = this.state;
        const MasterPage = Utils.getUsuarioEstaLogado() ? PrincipalMaster : PublicMaster;

        return (
            <MasterPage title="Inscrição" {...this.props}>
                {carregando && <Load />}
                <div className="padding-content">
                    <Stepper activeStep={stepIndex} >
                        <Step>
                            <StepLabel>EVENTO</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>CATEGORIA</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>ÁREA</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>EIXO</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>TEMA</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>AUTOR(ES)</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>TERMO DE INSCRIÇÃO</StepLabel>
                        </Step>
                    </Stepper>
                    <div>
                        {this.getStepContent(stepIndex)}
                    </div>
                </div>
            </MasterPage>
        );
    }
}

Inscricao.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            etapa: PropTypes.string,
            subevento: PropTypes.string,
            area: PropTypes.string,
            eixo: PropTypes.string,
        }),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

export default withRouter(Inscricao);
